import { useContext } from 'react';

import { OrdersRecognitionContext } from '@widgets/OrdersRecognition/model/context';

export const useOrdersRecognitionContext = () => {
    const context = useContext(OrdersRecognitionContext);
    if (!context) {
        throw new Error(
            'useOrdersRecognitionContext must be used within OrdersRecognitionContextProvider'
        );
    }
    return context;
};
